import { useEffect, useRef, useState } from "react";
//@ts-ignore
import { registerSW } from "virtual:pwa-register";

type UpdateFn = (reloadPage?: boolean) => Promise<void>;

export function usePwaUpdate() {
    const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);
    const updateRef = useRef<UpdateFn | null>(null);

    useEffect(() => {
        // immediate:true — сразу проверяет обновления на старте
        const updateSW = registerSW({
            immediate: true,

            // // вызывается, когда доступна новая версия и нужно спросить пользователя
            // onNeedRefresh() {
            //     setIsUpdateAvailable(true);
            // },
            //
            // // просто инфо: всё закэшировано для оффлайна
            // onOfflineReady() {
            //     // можно показать тост "Готово к оффлайну"
            // },
            //
            // // не обязательно, но полезно для логов
            // onRegisterError(error) {
            //     console.error("SW register error:", error);
            // },
        });

        updateRef.current = updateSW;
    }, []);

    // применяет обновление и перезагружает страницу
    const applyUpdate = () => updateRef.current?.(true);

    // можно также дать возможность «проверить обновления» вручную
    const checkForUpdate = () => updateRef.current?.(false);

    return { isUpdateAvailable, applyUpdate, checkForUpdate };
}